import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteTaskSetMutation($input: DeleteTaskSetInput!) {
		deleteTaskSet(input: $input) {
			deletedTaskSetId
			# The instances that went with it. The backend cannot read them back --
			# by the time the delete has succeeded the rows are gone -- so it returns
			# the ids it was given, and the store is cleaned from those.
			deletedTaskIds
			project {
				id
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	/* No declarative store config, deliberately. NODE_DELETE on the instances
	   removed the task records while the connections that list them kept their
	   edges, so the scoping page re-rendered with a null where each task had
	   been and threw in getExpandedTaskMap, which reads task.id. The delete had
	   already succeeded, so the reader saw an error over work that was gone.

	   The caller refetches instead -- the same choice create makes, and for the
	   same reason: this rewrites many rows at once, and reconciling them by hand
	   is what broke. */
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
